import React from 'react'
import { useContext } from 'react'
import { LANGUAGE_SHORT_CODE } from '../../constants'
import { multipleWordsProps } from '../../constants/Language'
import { SettingsContext } from '../../Parts/Settings'
  
const Word = (props) => {
  const settingsContext = useContext(SettingsContext)
  const { wid } = props
  var language = settingsContext.language ? settingsContext.language : LANGUAGE_SHORT_CODE.JA
  var wordProps = multipleWordsProps.find(wordProps => wordProps.wid === wid)
  var word = (wordProps === undefined || Boolean(wordProps[language]) === false) ? ' ' : wordProps[language]
  if (undefined !== props.insert) {
    Object.keys(props.insert).forEach(key => {
      word = word.replace(`{${key}}`, props.insert[key])
    })
  }
  
  return (
    <React.Fragment>{word}</React.Fragment>
  )
}

export default Word


// WEBPACK FOOTER //
// ./src/components/Common/Word.js